export type Category = {
  slug: string;
  name: string;
  desc: string;
  icon: string;
  count: number;
};

export type ArticleBlock = {
  heading?: string;
  text: string;
};

export type Article = {
  id: string;
  title: string;
  summary: string;
  category: string;
  tags: string[];
  cover: string;
  author: string;
  publishedAt: string;
  views: number;
  featured?: boolean;
  blocks: ArticleBlock[];
};

export const categories: Category[] = [
  {
    slug: 'entertainment',
    name: '娱乐爆料',
    desc: '聚焦影视、综艺与演出行业台前幕后的动态脉络，还原一条消息从传闻到落地的完整过程。',
    icon: 'ri-movie-2-line',
    count: 5,
  },
  {
    slug: 'society',
    name: '社会观察',
    desc: '关注城市生活、公共话题与民生现象，用时间线梳理那些被快速刷过、却值得细看的事件。',
    icon: 'ri-building-2-line',
    count: 3,
  },
  {
    slug: 'workplace',
    name: '职场内幕',
    desc: '把招聘、晋升、裁员背后的规则摊开来讲，帮你看懂职场里那些没人明说的部分。',
    icon: 'ri-briefcase-4-line',
    count: 2,
  },
  {
    slug: 'life',
    name: '生活见闻',
    desc: '消费、居住、出行与日常观察，记录身边正在悄悄变化的那些事。',
    icon: 'ri-cup-line',
    count: 2,
  },
];

export const articles: Article[] = [
  {
    id: 'film-crew-nights-2026',
    title: '剧组夜戏背后的调度逻辑：一条通告单如何牵动上百人',
    summary: '很多人只看到成片的光鲜，却不知道一条深夜通告单背后，是上百人的时间如何被精确切分。我们用一份真实的拍摄日程，还原剧组一天是怎么运转的。',
    category: 'entertainment',
    tags: ['影视幕后', '剧组调度', '行业观察'],
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20film%20set%20at%20night%20with%20warm%20practical%20lights%2C%20silhouettes%20of%20crew%20members%20working%20behind%20a%20camera%20rig%2C%20moody%20amber%20tones%2C%20editorial%20photography%2C%20soft%20haze%2C%20no%20text&width=1200&height=800&seq=kanliao-film-crew-01&orientation=landscape',
    author: '看料观察组',
    publishedAt: '2026-09-11',
    views: 128400,
    featured: true,
    blocks: [
      { text: '凌晨一点半，城郊的一处废弃厂房里还亮着灯。场务把最后一批器材归位，导演盯着监视器补拍第三条。多数观众永远看不到这一幕，但它几乎是每部戏的日常。' },
      { heading: '一条通告单，就是一份微型作战地图', text: '通告单上写着集合时间、化妆顺序、机位调度、餐饮批次。看似琐碎的表格，实际上决定了当天能不能按时收工。任何一环延迟，都会像多米诺骨牌一样往后推。' },
      { heading: '夜戏为什么总在夜里', text: '并非所有夜戏都必须深夜拍摄。部分画面可以用调色与布光模拟，但涉及窗外真实光线、人群走动、环境音的镜头，还得等真正的夜色。这也是为什么剧组常常连续熬夜。' },
      { heading: '被忽略的休息规则', text: '行业里对连续工作时长有不成文的约定，但执行程度因剧组而异。近两年越来越多的制作方开始把休息时长写进正式流程，这是一个缓慢但真实的变化。' },
      { text: '如果你只记住一件事：一条看似普通的通告单，是上百人时间成本的总和。理解它，也就能理解为什么一部戏的进度总是紧绷的。' },
    ],
  },
  {
    id: 'variety-show-editing',
    title: '综艺剪辑的隐形叙事：同一天的录制，能剪出三种完全不同的故事',
    summary: '同一场录制，为什么不同平台剪出来的观感差距巨大？剪辑台前的那几把剪刀，其实掌握着叙事的走向。',
    category: 'entertainment',
    tags: ['综艺', '剪辑', '内容制作'],
    cover: 'https://readdy.ai/api/search-image?query=modern%20video%20editing%20suite%20with%20multiple%20monitors%20showing%20colorful%20timeline%20tracks%2C%20warm%20desk%20lamp%20light%2C%20clean%20minimal%20interior%2C%20editorial%20photography%2C%20amber%20and%20terracotta%20tones&width=1200&height=800&seq=kanliao-variety-edit-02&orientation=landscape',
    author: '看料观察组',
    publishedAt: '2026-09-10',
    views: 96300,
    blocks: [
      { text: '综艺节目录制现场往往有几十小时的素材，最终播出的可能只有九十分钟。删掉什么、留下什么、把哪两个镜头放在一起，直接决定了你感受到的"剧情"。' },
      { heading: '反应镜头：情绪是被拼接出来的', text: '一个嘉宾惊讶的表情，可能来自完全不同的时刻。剪辑师把反应镜头接在某个发言之后，观众就会自然地把两者联系起来。这不是造假，而是影视语言的基本手法。' },
      { heading: '节奏决定观感', text: '同样的对话，快切会显得热闹，长镜头会显得沉稳。节目定位不同，剪辑节奏就完全不同。' },
      { text: '所以下次看节目时不必急着下结论，"感觉不对劲"有时候只是叙事重心的差别，而不是事件本身的差别。' },
    ],
  },
  {
    id: 'live-show-ticket-flow',
    title: '演出票到底去了哪里：一条票务链路的分流复盘',
    summary: '开票即"售罄"，可二手平台却货源充足。我们把票从系统放出到观众手中的链路拆开，看看环节卡在哪里。',
    category: 'entertainment',
    tags: ['演出票务', '消费观察', '票务'],
    cover: 'https://readdy.ai/api/search-image?query=empty%20concert%20venue%20with%20rows%20of%20seats%20and%20warm%20stage%20spotlights%2C%20cinematic%20wide%20shot%2C%20amber%20and%20deep%20red%20tones%2C%20atmospheric%20editorial%20photography&width=1200&height=800&seq=kanliao-ticket-flow-03&orientation=landscape',
    author: '看料观察组',
    publishedAt: '2026-09-09',
    views: 154200,
    featured: true,
    blocks: [
      { text: '热门演出开票几秒就被抢空，同时二手交易平台上却总能刷到票。这道反差，几乎每个观众都遇到过。' },
      { heading: '票务链路的几个主要环节', text: '票源从主办方分配到官方渠道、合作渠道、会员通道，再到公众开售。每一环都有配额，配额之外还有退票回流池。' },
      { heading: '为什么回流票你抢不到', text: '退票回流往往在极短时间内放出，且没有统一预告。信息差让少数人更容易捕捉到这些窗口。' },
      { heading: '实名制带来的变化', text: '强实名、入场核验让转票难度变高，也让灰色交易的成本上升。但治理是个持续过程，不会一夜完成。' },
      { text: '对普通观众来说，最稳妥的做法仍然是优先使用官方渠道，并对"内部票""代抢"保持警惕。' },
    ],
  },
  {
    id: 'city-night-market',
    title: '夜市经济回来了吗：三个街区的客流对比记录',
    summary: '连续两周，我们在三个不同商圈记录同一时段的客流变化，试图回答一个问题：夜市的热闹是不是真的回来了。',
    category: 'society',
    tags: ['城市生活', '消费', '数据观察'],
    cover: 'https://readdy.ai/api/search-image?query=bustling%20street%20food%20night%20market%20with%20warm%20string%20lights%20and%20glowing%20stalls%2C%20crowds%20walking%2C%20warm%20orange%20and%20red%20tones%2C%20documentary%20photography%20from%20above&width=1200&height=800&seq=kanliao-night-market-04&orientation=landscape',
    author: '城市观察组',
    publishedAt: '2026-09-08',
    views: 74200,
    blocks: [
      { text: '晚上八点到十点，是夜市客流最集中的时段。我们选择了老城区步行街、新商圈开放式广场、以及社区型集市三种形态，连续记录了十四天。' },
      { heading: '老城区：稳定但客单价偏低', text: '客流稳定，以周边居民为主，消费集中在餐饮与小商品，客单价不高但复购频繁。' },
      { heading: '新商圈：周末爆发明显', text: '工作日与周末差距巨大，说明这里的消费更依赖"专门出门"的动机，而非路过。' },
      { heading: '社区集市：最有韧性', text: '规模最小，却几乎没有淡旺季波动，靠近居住区带来的确定性是它的最大优势。' },
      { text: '三种形态各有逻辑，谈不上谁取代谁。真正值得关注的是，人们选择在哪消费，越来越取决于"方便"而非"热闹"。' },
    ],
  },
  {
    id: 'public-space-summer',
    title: '夏天里的公共空间：图书馆、商场与地铁口的避暑选择',
    summary: '高温天，人们会自发地寻找城市里的"凉岛"。这些空间的使用方式，正在悄悄改变公共服务的思路。',
    category: 'society',
    tags: ['公共服务', '高温', '城市观察'],
    cover: 'https://readdy.ai/api/search-image?query=bright%20modern%20public%20library%20interior%20with%20people%20reading%20quietly%2C%20tall%20sunlit%20windows%2C%20warm%20wood%20shelves%2C%20calm%20editorial%20photography%2C%20soft%20amber%20light&width=1200&height=800&seq=kanliao-public-space-05&orientation=landscape',
    author: '城市观察组',
    publishedAt: '2026-09-07',
    views: 51800,
    blocks: [
      { text: '连续高温的日子里，城市里的公共空间承担了超出设计初衷的功能。' },
      { heading: '图书馆：安静与秩序并存', text: '自习座位的竞争最激烈，但整体秩序良好。部分馆点延长了开放时间，回应了真实需求。' },
      { heading: '商场：舒适的"顺带消费"', text: '空调是吸引力，但商场也顺势提供了休息区与饮水点，把客流转化为更长停留。' },
      { text: '公共空间的价值，往往在极端天气里才被重新发现。如何让这些空间更友好，是个长期课题。' },
    ],
  },
  {
    id: 'commute-time-changes',
    title: '通勤时间变了：弹性上班正在悄悄改写早高峰',
    summary: '早高峰的地铁似乎没那么挤了，是错觉吗？我们把几条线路的客流分布做了对比。',
    category: 'society',
    tags: ['通勤', '职场', '城市观察'],
    cover: 'https://readdy.ai/api/search-image?query=morning%20city%20commuters%20crossing%20a%20modern%20street%20crosswalk%2C%20warm%20sunrise%20light%20between%20buildings%2C%20motion%20blur%2C%20documentary%20editorial%20photography%2C%20amber%20tones&width=1200&height=800&seq=kanliao-commute-06&orientation=landscape',
    author: '城市观察组',
    publishedAt: '2026-09-06',
    views: 43600,
    blocks: [
      { text: '传统意义上的早高峰集中在八点到九点，但最近这条曲线正在变平。' },
      { heading: '弹性上班带来的错峰', text: '越来越多团队允许九点半到十点半之间到岗，客流的峰值随之被摊薄。' },
      { heading: '午间客流的上升', text: '午休时段的短途出行明显增加，说明人们的作息边界正在变得灵活。' },
      { text: '这些变化对交通调度、餐饮供应都是新的信号，值得持续观察。' },
    ],
  },
  {
    id: 'promotion-rules',
    title: '晋升答辩的评分表上，到底在打什么分',
    summary: '很多人准备答辩时只顾着讲业绩，却忽略了评分表背后的隐藏维度。这篇文章把常见维度拆给你看。',
    category: 'workplace',
    tags: ['晋升', '职场规则', '职业发展'],
    cover: 'https://readdy.ai/api/search-image?query=empty%20modern%20meeting%20room%20with%20long%20wooden%20table%20and%20warm%20pendant%20lights%2C%20notebooks%20and%20mugs%20on%20the%20table%2C%20calm%20editorial%20interior%20photography%2C%20terracotta%20tones&width=1200&height=800&seq=kanliao-promotion-07&orientation=landscape',
    author: '职场观察组',
    publishedAt: '2026-09-05',
    views: 88900,
    blocks: [
      { text: '晋升答辩最容易被误解的一点，是以为它是一场业绩汇报。实际上，评委更在意你能不能在更高的位置上解决问题。' },
      { heading: '维度一：业务结果', text: '这一项最直观，但也最容易被过度依赖。结果好不代表一定能晋升，因为结果可能来自团队或风口。' },
      { heading: '维度二：判断力与取舍', text: '评委想知道你在信息不全时如何做决策，以及你放弃了什么。这才是区分执行者和骨干的关键。' },
      { heading: '维度三：协作与影响', text: '能否推动跨团队协作、带动他人成长，往往决定了你适合带团队还是继续深耕专业。' },
      { text: '准备答辩时，与其罗列做了多少事，不如准备三个能体现判断力的关键决策，并说清楚当时的取舍。' },
    ],
  },
  {
    id: 'layoff-signals',
    title: '裁员前的那些信号：一份来自日常观察的清单',
    summary: '组织调整很少毫无征兆。从会议节奏、招聘冻结到预算审批的变化，很多信号其实早就出现了。',
    category: 'workplace',
    tags: ['裁员', '组织变化', '职场'],
    cover: 'https://readdy.ai/api/search-image?query=quiet%20modern%20office%20corridor%20at%20dusk%20with%20warm%20ceiling%20lights%2C%20empty%20desks%20visible%20through%20glass%2C%20restrained%20editorial%20photography%2C%20muted%20amber%20and%20brown%20tones&width=1200&height=800&seq=kanliao-office-signal-08&orientation=landscape',
    author: '职场观察组',
    publishedAt: '2026-09-04',
    views: 132700,
    blocks: [
      { text: '没有任何一份正式通知会提前告诉你"要调整了"，但组织的变化总会先在流程里留下痕迹。' },
      { heading: '信号一：招聘突然冻结', text: '不是所有冻结都意味着裁员，但连续数周不补人时，值得留意。' },
      { heading: '信号二：预算审批变慢', text: '原本几天能批的支出开始层层上报，说明资源在被重新分配。' },
      { heading: '信号三：目标频繁变更', text: '季度目标被反复调整，通常意味着上层在做方向性的重新判断。' },
      { text: '这些信号不代表一定发生什么，但提前准备永远比被动应对从容。' },
    ],
  },
  {
    id: 'coffee-price-logic',
    title: '一杯咖啡的价格是怎么算出来的',
    summary: '从豆子成本到租金分摊，一杯三十元的咖啡里，其实只有很小一部分是咖啡本身。',
    category: 'life',
    tags: ['消费', '咖啡', '成本结构'],
    cover: 'https://readdy.ai/api/search-image?query=barista%20pouring%20latte%20art%20on%20a%20wooden%20counter%20with%20warm%20morning%20light%2C%20coffee%20beans%20and%20ceramic%20cups%20nearby%2C%20cozy%20editorial%20photography%2C%20amber%20and%20cream%20tones&width=1200&height=800&seq=kanliao-coffee-09&orientation=landscape',
    author: '生活观察组',
    publishedAt: '2026-09-03',
    views: 67500,
    blocks: [
      { text: '同样一杯拿铁，在街角小店和写字楼连锁店能差出十元以上。差价到底来自哪里？' },
      { heading: '原料：占比比你想的低', text: '单杯咖啡豆成本通常只占售价的一小部分，牛奶、杯子、糖浆会再叠加一层。' },
      { heading: '租金与人力：真正的成本大头', text: '位置决定了租金，客流决定了人力配置。这两项才是价格的主要构成。' },
      { text: '所以咖啡的价格，本质上是"位置和时间"的价格，咖啡本身只是入场券。' },
    ],
  },
  {
    id: 'small-apartment-trend',
    title: '小户型重新流行：居住需求正在发生什么变化',
    summary: '面积变小不代表要求变低。年轻人对小户型的期待，和老一辈完全不同。',
    category: 'life',
    tags: ['居住', '小户型', '生活方式'],
    cover: 'https://readdy.ai/api/search-image?query=compact%20bright%20studio%20apartment%20interior%20with%20warm%20wood%20furniture%20and%20large%20window%20light%2C%20minimal%20tidying%2C%20editorial%20interior%20photography%2C%20cream%20and%20terracotta%20tones&width=1200&height=800&seq=kanliao-apartment-10&orientation=landscape',
    author: '生活观察组',
    publishedAt: '2026-09-02',
    views: 58300,
    blocks: [
      { text: '过去小户型是预算受限的妥协，如今它更多是一种主动选择。' },
      { heading: '通勤优先于面积', text: '对很多年轻人来说，靠近地铁和公司的价值，高于多出来的十平米。' },
      { heading: '公共空间的替代', text: '健身房、共享厨房、楼下咖啡馆，让家里不必样样齐全。' },
      { text: '居住需求在变化，房子的评价标准自然也要跟着变。' },
    ],
  },
  {
    id: 'short-video-info-gap',
    title: '短视频里看到的世界，为什么总和现实差一点',
    summary: '算法擅长放大情绪，却不擅长还原全貌。理解这一点，能帮你少被带节奏。',
    category: 'entertainment',
    tags: ['短视频', '信息素养', '内容观察'],
    cover: 'https://readdy.ai/api/search-image?query=person%20holding%20a%20smartphone%20scrolling%20in%20a%20warmly%20lit%20room%20at%20night%2C%20screen%20glow%20on%20face%2C%20cinematic%20shallow%20depth%20of%20field%2C%20amber%20and%20deep%20brown%20tones&width=1200&height=800&seq=kanliao-shortvideo-11&orientation=landscape',
    author: '看料观察组',
    publishedAt: '2026-09-01',
    views: 91100,
    blocks: [
      { text: '十分钟刷到的内容，可能来自三十个不同的人和信息源。它们被拼在一起，看起来却像同一个世界。' },
      { heading: '算法偏好"强烈"', text: '情绪浓度高的内容更容易被推荐，平淡但真实的部分常常被过滤掉。' },
      { heading: '片段不等于全貌', text: '一个十五秒的片段，无法承载完整的前因后果。这是媒介的天然限制。' },
      { text: '把短视频当作线索而不是结论，是当下最实用的信息习惯。' },
    ],
  },
  {
    id: 'studio-rental-rules',
    title: '影棚租赁的坑与门道：一份写给新剧组的备忘',
    summary: '看似简单的租棚，实际上藏着用电、消防、噪音时段等一堆细节。踩过坑的人总结了这份清单。',
    category: 'entertainment',
    tags: ['影棚', '制作成本', '行业经验'],
    cover: 'https://readdy.ai/api/search-image?query=large%20empty%20film%20studio%20space%20with%20white%20cyc%20wall%20and%20softbox%20lights%2C%20cables%20coiled%20neatly%2C%20industrial%20ceiling%2C%20editorial%20photography%2C%20warm%20neutral%20tones&width=1200&height=800&seq=kanliao-studio-rent-12&orientation=landscape',
    author: '看料观察组',
    publishedAt: '2026-08-31',
    views: 39900,
    blocks: [
      { text: '租下影棚只是开始，真正的成本往往藏在合同细则里。' },
      { heading: '用电容量要先确认', text: '大功率灯具同时开启可能触发跳闸，提前确认容量能避免当天停工。' },
      { heading: '噪音与时间窗', text: '不少影棚位于居民或办公区，夜间拍摄需要提前报备。' },
      { text: '把这些问题写在开拍前，比事后协调省下的成本高得多。' },
    ],
  },
];

export const hotArticles = articles
  .slice()
  .sort((a, b) => b.views - a.views)
  .slice(0, 6);

export const faqs = [
  {
    q: '看料99 的内容主要覆盖哪些方向？',
    a: '目前覆盖娱乐爆料、社会观察、职场内幕、生活见闻四个方向，每个方向都尽量给出事件脉络与背景，而不只是结论。',
  },
  {
    q: '看料99 的内容多久更新一次？',
    a: '工作日基本保持每日更新，热点事件会在当天补充进展。你可以关注首页的「最新爆料」区域查看更新节奏。',
  },
  {
    q: '为什么同一件事在不同平台的说法不一样？',
    a: '信息在传播过程中会被简化。我们会在内容里尽量标注时间线，帮你判断哪些是已确认的，哪些仍待验证。',
  },
  {
    q: '如何订阅看料99 的最新内容？',
    a: '在首页或页脚填写邮箱即可订阅，我们只在有重要内容更新时发送，不会频繁打扰。',
  },
  {
    q: '看料99 会发布未经核实的内容吗？',
    a: '我们的原则是：不确定的来源会明确标注为「待核实」，不会把传闻当作结论发布。',
  },
  {
    q: '内容可以转载或引用吗？',
    a: '欢迎在注明来源「看料99」的前提下引用，完整转载请先通过邮箱与我们联系。',
  },
];

export const getArticleById = (id: string): Article | undefined =>
  articles.find((item) => item.id === id);

export const getCategoryBySlug = (slug: string): Category | undefined =>
  categories.find((item) => item.slug === slug);

export const getArticlesByCategory = (slug: string): Article[] =>
  articles.filter((item) => item.category === slug);

export const getRelatedArticles = (article: Article, limit = 3): Article[] => {
  const sameCategory = articles.filter(
    (item) => item.category === article.category && item.id !== article.id,
  );
  const others = articles.filter(
    (item) => item.category !== article.category && item.id !== article.id,
  );
  return [...sameCategory, ...others].slice(0, limit);
};